import {addBunchToMap} from "../overlay-utils";
import {legacyIncome} from "../../../../app/components/client/application-stages/_common/lender-tests/useXlsTests";
import {BoolLike, BuildType, EmploymentTypes} from "../../../../models";
import {
    balanceOfFundsCosts, balanceOfFundsFunds
} from "../../../../app/components/client/application-stages/_common/funding/BalanceOfFunds";
import dayjs from "dayjs";


export default function (mortgage, config) {
    function checkSelfEmployedExtraDocs() {
        let myDate = new Date(mortgage.requirement.aipDate)
        const today = new Date();
        const currentYear = today.getFullYear();
        const oct31CurrentYear = new Date(currentYear, 9, 31); // 31 October of the current year
        if (today > oct31CurrentYear && myDate < oct31CurrentYear) {
            return true;
        }
        return false;
    }

    const mortgageLoanAccountNumber = () => {
        let map = {}
        let errors = []
        const digits = mortgage.activeSubmission?.mortgageAccountNo
        if (!digits) {
            errors.push('No mortgage loan account number')
        } else {
            addBunchToMap(map, 'mortgage-account-number-', digits.toUpperCase().split(''))
        }
        return {map}
    }
    const addressLine1 = () => {
        let map = {}
        let ask = []
        let errors = []
        ask.push({
            label: 'Address Line 1',
            name: 'addressLine1',
            type: 'TEXT',
            group: 'DEBTOR ADDRESS'
        })
        if (!config.hasOwnProperty('addressLine1')) {
            errors.push('No address line 1')
        } else {
            addBunchToMap(map, 'debtor-address-1-', config.addressLine1.toUpperCase().split(''))
        }
        return {
            map,
            ask,
            errors
        }
    }
    const addressLine2 = () => {
        let map = {}
        let ask = []
        let errors = []
        ask.push({
            label: 'Address Line 2',
            name: 'addressLine2',
            type: 'TEXT',
            group: 'DEBTOR ADDRESS'
        })
        if (!config.hasOwnProperty('addressLine2')) {
            //errors.push('No address line 2')
        } else {
            addBunchToMap(map, 'debtor-address-2-', config.addressLine2.toUpperCase().split(''))
        }
        return {
            map,
            ask,
            errors
        }
    }
    const addressLine3 = () => {
        let map = {}
        let ask = []
        let errors = []
        ask.push({
            label: 'Address Line 3',
            name: 'addressLine3',
            type: 'TEXT',
            group: 'DEBTOR ADDRESS'
        })
        if (!config.hasOwnProperty('addressLine3')) {
            //errors.push('No address line 3')
        } else {
            addBunchToMap(map, 'debtor-address-3-', config.addressLine3.toUpperCase().split(''))
        }
        return {
            map,
            ask,
            errors
        }
    }
    const addressLine4 = () => {
        let map = {}
        let ask = []
        let errors = []
        ask.push({
            label: 'Address Line 4',
            name: 'addressLine4',
            type: 'TEXT',
            group: 'DEBTOR ADDRESS'
        })
        if (!config.hasOwnProperty('addressLine4')) {
            //errors.push('No address line 4')
        } else {
            addBunchToMap(map, 'debtor-address-4-', config.addressLine4.toUpperCase().split(''))
        }
        return {
            map,
            ask,
            errors
        }
    }
    const city = () => {
        let map = {}
        let ask = []
        let errors = []
        ask.push({
            label: 'City',
            name: 'city',
            type: 'TEXT',
            group: 'DEBTOR ADDRESS'
        })
        if (!config.hasOwnProperty('city')) {
            errors.push('No city')
        } else {
            addBunchToMap(map, 'city-', config.city.toUpperCase().split(''))
        }
        return {
            map,
            ask,
            errors
        }
    }
    const country = () => {
        let map = {}
        let ask = []
        let errors = []
        ask.push({
            label: 'Country',
            name: 'country',
            type: 'TEXT',
            group: 'DEBTOR ADDRESS'
        })
        if (!config.hasOwnProperty('country')) {
            errors.push('No country')
        } else {
            addBunchToMap(map, 'country-', config.country.toUpperCase().split(''))
        }
        return {
            map,
            ask,
            errors
        }
    }
    const debtorName = () => {
        let map = {}
        let ask = []
        let errors = []
        ask.push({
            label: 'Debtor Name',
            name: 'debtorName',
            type: 'TEXT',
            group: 'DEBTOR NAME'
        })
        if (!config.hasOwnProperty('debtorName')) {
            errors.push('No debtor name')
        } else {
            addBunchToMap(map, 'debtor-name-', config.debtorName.toUpperCase().split(''))
        }
        return {
            map,
            ask,
            errors
        }
    }
    const iban = () => {
        let map = {}
        let ask = []
        let errors = []
        ask.push({
            label: 'IBAN',
            name: 'iban',
            type: 'TEXT',
            group: 'IBAN'
        })
        if (!config.hasOwnProperty('iban')) {
            errors.push('No IBAN')
        } else {
            addBunchToMap(map, 'iban-', config.iban.toUpperCase().split(''))
        }
        return {
            map,
            ask,
            errors
        }
    }
    const postCode = () => {
        let map = {}
        let ask = []
        let errors = []
        ask.push({
            label: 'Post Code',
            name: 'postCode',
            type: 'TEXT',
            group: 'DEBTOR ADDRESS'
        })
        if (!config.hasOwnProperty('postCode')) {
            errors.push('No post code')
        } else {
            addBunchToMap(map, 'post-code-', config.postCode.toUpperCase().split(''))
        }
        return {
            map,
            ask,
            errors
        }
    }

    // ---

    const header = () => {
        let map = {}
        let ask = []
        let errors = []
        map['sussd-mortgages'] = `Truss Mortgages Ltd T/A Suss'd Mortgages`
        map['broker-phone-number'] = `01 685-4888`
        map['broker-email-address'] = `help@sussd.ie`
        return {
            map,
            ask,
            errors
        }
    }
    const applicant1Name = () => {
        let map = {}
        let errors = []
        const name = mortgage.applicant1.fullName.toUpperCase()
        if (!name) {
            errors.push('No name for applicant 1')
        } else {
            map['app1-full-name'] = name
        }
        return {
            map,
            errors
        }
    }
    const applicant2Name = () => {
        let map = {}
        let errors = []
        if (mortgage.twoApplicants) {
            const name = mortgage.applicant2.fullName.toUpperCase()
            if (!name) {
                errors.push('No name for applicant 2')
            } else {
                map['app2-full-name'] = name
            }
        }
        return {
            map,
            errors
        }
    }
    const term = mortgage.activeSubmission.finalTerm ?? mortgage.activeSubmission.aipTerm ?? mortgage.activeSubmission.provisionalTerm ?? mortgage.requirement.termRequired
    const drawDownDate = mortgage.activeSubmission.drawDownDate
    const closingDate = drawDownDate ? dayjs(drawDownDate, "YYYY-MM-DD") : dayjs().add(2, 'month');
    const termFinishDate = closingDate.add(term, 'year')
    const mortgageTerm = () => {
        let map = {}
        let ask = []
        let errors = []
        map['mortgage-term'] = term + 'yr'
        return {
            map,
            ask,
            errors
        }
    }
    const applicant1Age = () => {
        const app1Dob = mortgage.applicant1.personal.dateOfBirth ? dayjs(mortgage.applicant1.personal.dateOfBirth, "YYYY-MM-DD") : null
        const ageAtEndOfTerm = termFinishDate.diff(app1Dob, 'year', true)
        let map = {}
        let ask = []
        let errors = []
        if (app1Dob) {
            map['app1-age-end-of-term'] = ageAtEndOfTerm.toFixed(1)
        }
        return {
            map,
            ask,
            errors
        }
    }
    const applicant2Age = () => {
        let map = {}
        let ask = []
        let errors = []
        if (mortgage.twoApplicants) {
            const app2Dob = mortgage.applicant2.personal.dateOfBirth ? dayjs(mortgage.applicant2.personal.dateOfBirth, "YYYY-MM-DD") : null
            const ageAtEndOfTerm = termFinishDate.diff(app2Dob, 'year', true)
            console.log({app2Dob, ageAtEndOfTerm})
            if (app2Dob) {
                map['app2-age-end-of-term'] = ageAtEndOfTerm.toFixed(1)
            }
        }
        return {
            map,
            ask,
            errors
        }
    }


    const app1DOB = mortgage.applicant1.personal?.dateOfBirth ? dayjs(mortgage.applicant1.personal.dateOfBirth) : null
    const app2DOB = mortgage.twoApplicants && mortgage.applicant2.personal?.dateOfBirth ? dayjs(mortgage.applicant2.personal.dateOfBirth) : null
    const app1Age = app1DOB ? dayjs().diff(app1DOB, 'year', true) : null
    const roundedApp1Age = app1Age ? Math.round(app1Age) : null
    const app2Age = app2DOB ? dayjs().diff(app2DOB, 'year', true) : null
    const roundedApp2Age = app2Age ? Math.round(app2Age) : null
    const requestedTerm = mortgage.activeSubmission?.verifiedFiguresTest?.term || mortgage.activeSubmission?.finalTerm || mortgage.activeSubmission?.provisionalTerm || mortgage.requirement.loanTerm
    const retirementAge = 66
    const app1BeyondRetirement = roundedApp1Age ? roundedApp1Age + requestedTerm > retirementAge : null
    const app2BeyondRetirement = mortgage.twoApplicants && roundedApp2Age ? roundedApp2Age + requestedTerm > retirementAge : null
    const aipDate = mortgage.activeSubmission.aipDate ? dayjs(mortgage.activeSubmission.aipDate, "YYYY-MM-DD") : null
    const midPoint = aipDate ? aipDate.add(6, 'month') : null
    const is6monthsSinceAIP = midPoint ? dayjs().isAfter(midPoint) : false
    const app1GoAhead = () => {
        return {
            map: {
                'app1-go-ahead-yes': true,
            }
        }
        // if (app1BeyondRetirement) {
        //     return {
        //         map: {
        //             'app1-go-ahead-na': true,
        //             'app1-mortgage-term-finish-yes': true
        //         }
        //     }
        // }
        // return {
        //     map: {
        //         'app1-go-ahead-yes': true,
        //         'app1-mortgage-term-finish-na': true
        //     }
        // }
    }
    const app2GoAhead = () => {
        let map = {}
        if (mortgage.twoApplicants) {
            return {
                map: {
                    'app2-go-ahead-yes': true,
                }
            }
            // if (app2BeyondRetirement) {
            //     map['app2-go-ahead-na'] = true
            //     map['app2-mortgage-term-finish-yes'] = true
            // } else {
            //     map['app2-go-ahead-yes'] = true
            //     map['app2-mortgage-term-finish-na'] = true
            // }
        }
        else{
            return {
                map: {
                    'app2-go-ahead-na': true,
                }
            }
            //
            // map['app2-go-ahead-na'] = true
            // map['app2-mortgage-term-finish-na'] = true
        }
        // return {
        //     map
        // }
    }

    const amendAIPAsApproved = () => {
        let map = {}
        let ask = []
        let errors = []
        ask.push({
            label: 'Amend AIP Approved Details',
            name: 'details',
            type: 'TEXT',
            group: 'Section 1'
        })
        map['advice-amended-aip-details']
            = config.hasOwnProperty('details') ? config.details : 'NO CHANGE TO AIP. ALL CONDITIONS MET'
        return {
            map,
            ask,
            errors
        }
    }
    const amendAIPAdditionalInfo = () => {
        let map = {}
        let ask = []
        let errors = []
        ask.push({
            label: 'Amend AIP Additional Info ',
            name: 'amendAIPAdditionalInfo',
            type: 'TEXT',
            group: 'Section 1'
        })
        map['advice-amended-aip-details-additional-information']
            = config.hasOwnProperty('amendAIPAdditionalInfo') ? config.amendAIPAdditionalInfo : ''
        return {
            map,
            ask,
            errors
        }
    }
    const valuationReportReviewed = () => {
        let map = {}
        let ask = []
        let errors = []
        map['valuation-report-reviewed-yes'] = true
        map['valuation-report-reviewed-no'] = false
        return {
            map,
            ask,
            errors
        }
    }

    const politicallyExposedPerson1 = () => {
        let map = {}
        let ask = []
        let errors = []
        map['app1-pep-yes'] = 'No'
        //map['app1-pep-no'] = true
        return {
            map,
            ask,
            errors
        }
    }
    const politicallyExposedPerson2 = () => {
        let map = {}
        let ask = []
        let errors = []
        if (mortgage.twoApplicants) {
            map['app2-pep-yes'] = 'No'
            //map['app2-pep-no'] = true
        }

        return {
            map,
            ask,
            errors
        }
    }
    const highNetWorthApp1 = () => {
        let map = {}
        let ask = []
        let errors = []
        map['app1-high-net-worth-customer-yes'] = 'No'
        //map['app1-high-net-worth-customer-no'] = true
        return {
            map,
            ask,
            errors
        }
    }
    const highNetWorthApp2 = () => {
        let map = {}
        let ask = []
        let errors = []
        if (mortgage.twoApplicants) {
            map['app2-high-net-worth-customer-yes'] = 'No'
            //map['app2-high-net-worth-customer-no'] = true
        }
        return {
            map,
            ask,
            errors
        }
    }
    const identification = () => {
        let map = {}
        let ask = []
        let errors = []
        map['app1-valid-passport-yes'] = true
        map['app1-valid-utility-bill-yes'] = true
        if (mortgage.twoApplicants) {
            map['app2-valid-passport-yes'] = true
            map['app2-valid-utility-bill-yes'] = true
        }
        return {
            map,
            ask,
            errors
        }
    }

    const aipDocsAddressed = () => {
        let map = {}
        let ask = []
        let errors = []
        map['mistake-wipeout'] = "---------------------------------------------------------------------------------------------------------------------   payslips"

        if (is6monthsSinceAIP) {
            map['plus6-app1-all-aip-conditions'] = true
            if (mortgage.twoApplicants) {
                map['plus6-app2-all-aip-conditions'] = true
            }
        }
        else{
            map['app1-all-aip-conditions'] = true
            if (mortgage.twoApplicants) {
                map['app2-all-aip-conditions'] = true
            }
        }


        return {
            map,
            ask,
            errors
        }
    }

    const payeDocs = () => {
        let map = {}
        let ask = []
        let errors = []
        if (legacyIncome(mortgage)) {
            let paye1 = mortgage.applicant1.employmentType === EmploymentTypes.EMPLOYED
            map['app1-most-recent-payslip-yes'] = !!paye1
            map['app1-bank-statement-yes'] = !!paye1
            let self1 = mortgage.applicant1.employmentType === EmploymentTypes.SELFEMPLOYED
            map['app1-months-non-aib-statement'] = !!self1
            if (mortgage.twoApplicants) {
                let paye2 = mortgage.applicant2.employmentType === EmploymentTypes.EMPLOYED
                map['app2-most-recent-payslip-yes'] = !!paye2
                map['app2-bank-statement-yes'] = !!paye2
                let self2 = mortgage.applicant2.employmentType === EmploymentTypes.SELFEMPLOYED
                map['app2-months-non-aib-statement'] = !!self2
            }
        } else {
            let paye1 = mortgage.applicant1.employmentIncome.find(it => it.employmentType === EmploymentTypes.EMPLOYED)
            if (is6monthsSinceAIP) {
                map['plus6-app1-most-recent-payslip-yes'] = !!paye1
                map['plus6-app1-bank-statement-yes'] = !!paye1
            }
            else{
                map['app1-most-recent-payslip-yes'] = !!paye1
                map['app1-bank-statement-yes'] = !!paye1
            }

            let self1 = mortgage.applicant1.employmentIncome.find(it => it.employmentType === EmploymentTypes.SELFEMPLOYED)
            if (is6monthsSinceAIP) {
                map['plus6-app1-months-non-aib-statement'] = !!self1
                map['plus6-self-app1-bank-statement-yes'] = !!self1
            }
            else{
                map['app1-months-non-aib-statement'] = !!self1
                map['self-app1-bank-statement-yes'] = !!self1
            }

            if (mortgage.twoApplicants) {
                let paye2 = mortgage.applicant2.employmentIncome.find(it => it.employmentType === EmploymentTypes.EMPLOYED)
                if (is6monthsSinceAIP) {
                    map['plus6-app2-most-recent-payslip-yes'] = !!paye2
                    map['plus6-app2-bank-statement-yes'] = !!paye2
                }
                else{
                    map['app2-most-recent-payslip-yes'] = !!paye2
                    map['app2-bank-statement-yes'] = !!paye2
                }

                let self2 = mortgage.applicant2.employmentIncome.find(it => it.employmentType === EmploymentTypes.SELFEMPLOYED)
                if (is6monthsSinceAIP) {
                    map['plus6-app2-months-non-aib-statement'] = !!self2
                    map['plus6-self-app2-bank-statement-yes'] = !!self2
                }
                else{
                    map['app2-months-non-aib-statement'] = !!self2
                    map['self-app2-bank-statement-yes'] = !!self2
                }

            }
        }
        return {
            map,
            ask,
            errors
        }
    }

    const foreignCreditReport = ()=>{
        let map = {}
        let today = dayjs()
        let fcr1 = mortgage.uploadSections.find(u=>u.name === 'foreign-credit-report-1' && u.activeUploads.length)
        if (fcr1 && fcr1.activeUploads.some(u=>u.values.documentDate.add(6,'month').isAfter(today))){
            map['foreign-credit-1'] = true
        }
        let fcr2 = mortgage.twoApplicants && mortgage.uploadSections.find(u=>u.name === 'foreign-credit-report-2' && u.activeUploads.length)
        if (fcr2 && fcr2.activeUploads.length && fcr2.activeUploads.some(u=>u.values.documentDate.add(6,'month').isAfter(today))){
            map['foreign-credit-2'] = true
        }
        console.log({fcr1,fcr2, map})
        return {
            map,
            ask: [],
            errors: []
        }


    }
    const funding = () => {
        const {
            price,
            stampDuty,
            legalFees,
            propertyValuation,
            totalCosts
        } = balanceOfFundsCosts(mortgage)

        const costs = [
            {
                key: 1,
                name: "Price",
                amount: price
            },
            {
                key: 2,
                name: "Stamp Duty",
                amount: stampDuty
            },
            {
                key: 3,
                name: "Legal Fees",
                amount: legalFees
            },
            {
                key: 4,
                name: "Property Valuation",
                amount: propertyValuation
            }
        ]

        //Funds
        const {
            loan,
            gifts,
            helpToBuy,
            firstHome,
            requiredSavings,
            bookingDepositPaid,
            contractDepositPaid
        } = balanceOfFundsFunds(mortgage)

        const funds = []
        if (loan > 0) {
            funds.push({
                key: 0,
                name: "Mortgage",
                amount: loan
            })
        }
        if (gifts > 0) {
            funds.push({
                key: 1,
                name: "Gifts",
                amount: gifts
            })
        }
        if (helpToBuy > 0) {
            funds.push({
                key: 2,
                name: "Help to Buy",
                amount: helpToBuy
            })
        }
        if (firstHome > 0) {
            funds.push({
                key: 3,
                name: "First Home",
                amount: firstHome
            })
        }
        if (bookingDepositPaid > 0) {
            funds.push({
                key: 4,
                name: "Booking Deposit Paid",
                amount: bookingDepositPaid
            })
        }
        if (contractDepositPaid > 0) {
            funds.push({
                key: 5,
                name: "Contract Deposit Paid",
                amount: contractDepositPaid
            })
        }
        funds.push({
            key: 6,
            name: "Savings",
            amount: requiredSavings
        })

        //Nicely space the cells so totals are at the bottom
        if (funds.length > costs.length) {
            let diff = funds.length - costs.length
            for (let i = 0; i < diff; i++) {
                costs.push({
                    key: `c.${i}`,
                    name: "",
                    amount: ""
                })
            }
        } else if (costs.length > funds.length) {
            let diff = costs.length - funds.length
            for (let i = 0; i < diff; i++) {
                funds.push({
                    key: `f.${i}`,
                    name: "",
                    amount: ""
                })
            }
        }
        costs.push({
            key: 'tF',
            name: "TOTAL",
            amount: totalCosts
        })
        funds.push({
            key: 'tC',
            name: "TOTAL",
            amount: totalCosts
        })

        let map = {}
        let ask = []
        let errors = []
        costs.forEach((cost, index) => {
            map[`bof-fund-desc-${index + 1}`] = cost.name
            map[`bof-fund-value-${index + 1}`] = cost.amount.toString()
        })
        funds.forEach((fund, index) => {
            map[`bof-cost-desc-${index + 1}`] = fund.name
            map[`bof-cost-value-${index + 1}`] = fund.amount.toString()
        })

        return {
            map,
            ask,
            errors
        }
    }

    const additionalDocsSelfEmployed = () => {
        let map = {}
        let ask = []
        let errors = []
        if (checkSelfEmployedExtraDocs()) {
            if (legacyIncome(mortgage)) {
                if (mortgage.applicant1.employment.employmentType === EmploymentTypes.SELFEMPLOYED) {
                    map['app1-up-to-date-certified-accounts-by-accountant'] = true
                }
                if (mortgage.applicant2.employment.employmentType === EmploymentTypes.SELFEMPLOYED) {
                    map['app2-up-to-date-certified-accounts-by-accountant'] = true
                }
            } else {
                if (mortgage.applicant1.employmentIncome.find(e => e.employmentType === EmploymentTypes.SELFEMPLOYED)) {
                    map['app1-up-to-date-certified-accounts-by-accountant'] = true
                }
                if (mortgage.applicant2.employmentIncome.find(e => e.employmentType === EmploymentTypes.SELFEMPLOYED)) {
                    map['app2-up-to-date-certified-accounts-by-accountant'] = true
                }
            }
        }
        return {
            map,
            ask,
            errors
        }
    }

    const helpToBuy = () => {
        let map = {}
        let ask = []
        let errors = []
        if (mortgage.requirement.helpToBuyScheme === BoolLike.TRUE) {
            map['app1-help-to-buy-acknowledgement-form'] = true
            map['app1-help-to-buy-access-code'] = true
            map['app1-help-to-buy-developer-name'] = true
        }
        return {
            map,
            ask,
            errors
        }
    }
    const firstHomeScheme = () => {
        let map = {}
        let ask = []
        let errors = []
        let fhs = mortgage.uploadSections.find(u=>u.name === 'first-home-scheme')
        if (fhs) {
            map['app1-first-home-scheme'] = true
            map['app1-first-home-scheme-within-mpm'] = true
            map['app1-first-home-scheme-max-eligibility'] = true
        }
        console.log({fhs})
        return {
            map,
            ask,
            errors
        }
    }
    const costOfConstruction = () => {
        let map = {}
        let ask = []
        let errors = []
        // ask.push({
        //     label: 'Cost of Construction',
        //     name: 'costOfConstruction',
        //     type: 'CHECK',
        //     group: 'Self Build - No work Commenced'
        // })
        if (mortgage.property.buildType === BuildType.SELFBUILD && !mortgage.property.constructionStarted){
            map['app1-cost-of-construction'] = true
        }
        // map['app1-cost-of-construction']
        //     = config.hasOwnProperty('costOfConstruction') ? config.costOfConstruction : false
        // if (!mortgage.property.constructionStarted){
        //     map['app1-cost-of-construction'] = true
        // }

        return {
            map,
            ask,
            errors
        }
    }
    const siteValue = () => {
        let map = {}
        let ask = []
        let errors = []
        // ask.push({
        //     label: 'Site Value',
        //     name: 'siteValue',
        //     type: 'CHECK',
        //     group: 'Self Build - No work Commenced'
        // })
        // map['app1-site-value-input']
        //     = config.hasOwnProperty('siteValue') ? config.siteValue : false
        if (mortgage.property.buildType === BuildType.SELFBUILD && !mortgage.property.constructionStarted){
            map['app1-site-value-input'] = true
        }
        return {
            map,
            ask,
            errors
        }
    }

    const propertySize = () => {
        let map = {}
        let ask = []
        let errors = []
        // ask.push({
        //     label: 'Property Size',
        //     name: 'propertySize',
        //     type: 'CHECK',
        //     group: 'Self Build - No work Commenced'
        // })
        // map['app1-property-size']
        //     = config.hasOwnProperty('propertySize') ? config.propertySize : false
        if (mortgage.property.buildType === BuildType.SELFBUILD && !mortgage.property.constructionStarted){
            map['app1-property-size'] = true
        }
        return {
            map,
            ask,
            errors
        }
    }
    const architectsPI = () => {
        let map = {}
        let ask = []
        let errors = []
        // ask.push({
        //     label: 'Architects PI Provided',
        //     name: 'architectsPI',
        //     type: 'CHECK',
        //     group: 'Self Build - No work Commenced'
        // })
        // map['app1-architecs-pi-provided']
        //     = config.hasOwnProperty('architectsPI') ? config.architectsPI : false
        if (mortgage.property.buildType === BuildType.SELFBUILD && !mortgage.property.constructionStarted){
            map['app1-architecs-pi-provided'] = true
        }
        return {
            map,
            ask,
            errors
        }
    }
    const finalGrant = () => {
        let map = {}
        let ask = []
        let errors = []
        // ask.push({
        //     label: 'Final Grant of Planning',
        //     name: 'finalGrant',
        //     type: 'CHECK',
        //     group: 'Self Build - No work Commenced'
        // })
        // map['app1-final-grant-of-planning']
        //     = config.hasOwnProperty('finalGrant') ? config.finalGrant : false
        if (mortgage.property.buildType === BuildType.SELFBUILD && !mortgage.property.constructionStarted){
            map['app1-final-grant-of-planning'] = true
        }
        return {
            map,
            ask,
            errors
        }
    }
    const planningApproved = () => {
        let map = {}
        let ask = []
        let errors = []
        if (mortgage.property.buildType === BuildType.SELFBUILD && !mortgage.property.constructionStarted) {
            ask.push({
                label: 'Planning Approved for Garage (not being built)',
                name: 'planningApproved',
                type: 'CHECK',
                group: 'Self Build - No work Commenced'
            })
            map['app1-planning-approved-for-garage']
                = config.hasOwnProperty('planningApproved') ? config.planningApproved : false
        }
        return {
            map,
            ask,
            errors
        }
    }
    const costOfConstructionWorksStarted = () => {
        let map = {}
        let ask = []
        let errors = []
        // ask.push({
        //     label: 'Cost of Construction',
        //     name: 'costOfConstructionWorksStarted',
        //     type: 'CHECK',
        //     group: 'Self Build - Work Has Commenced'
        // })
        // map['app1-cost-of-instruction-w']
        //     = config.hasOwnProperty('costOfConstructionWorksStarted') ? config.costOfConstructionWorksStarted : false
        if (mortgage.property.buildType === BuildType.SELFBUILD && mortgage.property.constructionStarted){
            map['app1-cost-of-instruction-w'] = true
        }
        return {
            map,
            ask,
            errors
        }
    }
    const letterOfSupervision = () => {
        let map = {}
        let ask = []
        let errors = []
        // ask.push({
        //     label: 'Letter of Supervision',
        //     name: 'letterOfSupervision',
        //     type: 'CHECK',
        //     group: 'Self Build - Work Has Commenced'
        // })
        // map['app1-letter-of-supervision']
        //     = config.hasOwnProperty('letterOfSupervision') ? config.letterOfSupervision : false
        if (mortgage.property.buildType === BuildType.SELFBUILD && mortgage.property.constructionStarted){
            map['app1-letter-of-supervision'] = true
        }
        return {
            map,
            ask,
            errors
        }
    }

    let engineersConfirmation = () => {
        let map = {}
        let ask = []
        let errors = []
        // ask.push({
        //     label: 'Engineers Confirmation',
        //     name: 'engineersConfirmation',
        //     type: 'CHECK',
        //     group: 'Self Build - Work Has Commenced'
        // })
        // map['app1-engineer-confirmation']
        //     = config.hasOwnProperty('engineersConfirmation') ? config.engineersConfirmation : false
        if (mortgage.property.buildType === BuildType.SELFBUILD && mortgage.property.constructionStarted){
            map['app1-engineer-confirmation'] = true
        }
        return {
            map,
            ask,
            errors
        }
    }

    let satisfactoryEvidence = () => {
        let map = {}
        let ask = []
        let errors = []
        // ask.push({
        //     label: 'Satisfactory Evidence',
        //     name: 'satisfactoryEvidence',
        //     type: 'CHECK',
        //     group: 'Self Build - Work Has Commenced'
        // })
        // map['app1-satisfactory-evidence']
        //     = config.hasOwnProperty('satisfactoryEvidence') ? config.satisfactoryEvidence : false
        if (mortgage.property.buildType === BuildType.SELFBUILD && mortgage.property.constructionStarted){
            map['app1-satisfactory-evidence'] = true
        }
        return {
            map,
            ask,
            errors
        }
    }

    let laapsSection = ()=>{
        let map = {}
        let ask = []
        let errors = []
        ask.push({
            label: 'LAAPS Approval Letter',
            name: 'app1-using-laaps',
            type: 'CHECK',
            group: 'LAAPS'
        })
        ask.push({
            label: 'Purchase Price on Approval Letter',
            name: 'app1-agreed-prrice-on-approcal',
            type: 'TEXT',
            group: 'LAAPS'
        })

        ask.push({
            label: 'Market Value on Approval Letter',
            name: 'app1-agreed-price-on-market-value',
            type: 'TEXT',
            group: 'LAAPS'
        })
        ask.push({
            label: 'Updated Approval Letter if Amount Different on AIP',
            name: 'app1-amount-different-on-aip',
            type: 'CHECK',
            group: 'LAAPS'
        })
        map['app1-using-laaps'] = config['app1-using-laaps'] ?? false
        map['app1-agreed-prrice-on-approcal'] = config['app1-agreed-prrice-on-approcal'] ?? ''
        map['app1-amount-different-on-aip'] = config['app1-amount-different-on-aip'] ?? false
        map['app1-agreed-price-on-market-value'] = config['app1-agreed-price-on-market-value'] ?? ''
        return {
            map,
            ask,
            errors
        }
    }
    const governmentSchemeSwitcher = ()=>{
        let map = {}
        let ask = []
        let errors = []
        ask.push({
            label: 'Switching/TopUp with Government Scheme',
            name: 'app1-switching',
            type: 'CHECK',
            group: 'Government Scheme Switch/TopUp'
        })
        ask.push({
            label: 'First Home Scheme',
            name: 'app1-first-home-scheme-yes',
            type: 'CHECK',
            group: 'Government Scheme Switch/TopUp'
        })
        ask.push({
            label: 'Local Authority Affordable Purchase Scheme',
            name: 'app1-local-authority-affordable-purchase-scheme',
            type: 'CHECK',
            group: 'Government Scheme Switch/TopUp'
        })
        ask.push({
            label: 'No Objection Letter Received',
            name: 'app1-no-objection-letter',
            type: 'CHECK',
            group: 'Government Scheme Switch/TopUp'
        })
        ask.push({
            label: 'Max Loan on No Objection Letter',
            name: 'app1-max-amount-objection-letter',
            type: 'TEXT',
            group: 'Government Scheme Switch/TopUp'
        })
        map['app1-switching'] = config['app1-switching'] ?? false
        map['app1-first-home-scheme-yes'] = config['app1-first-home-scheme-yes'] ?? false
        map['app1-local-authority-affordable-purchase-scheme'] = config['app1-local-authority-affordable-purchase-scheme'] ?? false
        map['app1-no-objection-letter'] = config['app1-no-objection-letter'] ?? false
        map['app1-max-amount-objection-letter'] = config['app1-max-amount-objection-letter'] ?? ''
        return {
            map,
            ask,
            errors
        }
    }

    const sections = [
        header(),
        mortgageLoanAccountNumber(),
        applicant1Name(),
        applicant2Name(),
        mortgageTerm(),
        applicant1Age(),
        applicant2Age(),
        app1GoAhead(),
        app2GoAhead(),
        foreignCreditReport(),
        amendAIPAsApproved(),
        amendAIPAdditionalInfo(),
        valuationReportReviewed(),
        politicallyExposedPerson1(),
        politicallyExposedPerson2(),
        highNetWorthApp1(),
        highNetWorthApp2(),
        identification(),
        aipDocsAddressed(),
        payeDocs(),
        funding(),
        additionalDocsSelfEmployed(),
        firstHomeScheme(),
        helpToBuy(),
        costOfConstruction(),
        siteValue(),
        propertySize(),
        architectsPI(),
        finalGrant(),
        planningApproved(),
        costOfConstructionWorksStarted(),
        letterOfSupervision(),
        engineersConfirmation(),
        satisfactoryEvidence(),
        laapsSection(),
        governmentSchemeSwitcher()

    ]

    return {sections}
}
